import { Controller } from "@hotwired/stimulus"

// Sortiert server-gerenderte Tabellenzeilen nach data-sort-<key> der <tr>.
// Spaltenköpfe: <th data-table-sort-target="header" data-key="…" aria-sort="…"><button data-action="table-sort#sort" data-table-sort-key-param="…">
export default class extends Controller {
  static targets = ["body", "header"]

  connect() {
    this.collator = new Intl.Collator("de", { sensitivity: "base", numeric: true })
  }

  sort({ params: { key } }) {
    const header = this.headerTargets.find(th => th.dataset.key === key)
    const current = header?.getAttribute("aria-sort")
    // Namen starten aufsteigend, Beträge absteigend (teuerste zuerst wie im Server-Render)
    const firstDirection = key === "name" ? "ascending" : "descending"
    const direction = current === "none" || !current ? firstDirection : (current === "ascending" ? "descending" : "ascending")
    const factor = direction === "ascending" ? 1 : -1

    const rows = Array.from(this.bodyTarget.rows)
    rows.sort((a, b) => {
      const x = a.dataset[`sort${this.capitalize(key)}`]
      const y = b.dataset[`sort${this.capitalize(key)}`]
      const compared = key === "name" ? this.collator.compare(x, y) : Number(x) - Number(y)
      return compared * factor
    })
    this.bodyTarget.append(...rows)

    this.headerTargets.forEach(th => {
      const active = th === header
      th.setAttribute("aria-sort", active ? direction : "none")
      const arrow = th.querySelector("[data-sort-arrow]")
      if (arrow) arrow.textContent = active ? (direction === "ascending" ? "↑" : "↓") : "↕"
    })
  }

  capitalize(key) {
    return key.charAt(0).toUpperCase() + key.slice(1)
  }
}
